
import { defineComponent } from "vue";
import "@/assets/scss/patient/versions.scss";
import LoadingScreen from "@/components/LoadingScreen.vue";
import axios from "axios";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "versions",
  components: {
    LoadingScreen,
  },
  data() {
    return {
      active: false,
      isLoading: true,
      red: "red",
      normal: "normal",
      yellow: "yellow",
      versions: [] ,
      textOrder: "",
    };
  },
  methods: {
    show(body:string) {
      this.active = true;
      this.textOrder = body;
    },
    fetchVersions() {
      axios
        .get("patient/prescriptions")
        .then((res) => {
          // console.log(res.data);
          this.versions = res.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.fetchVersions();
  },
});
